"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineFilterProcessor = void 0;
/**
 * The `filter` processor allows conditional processing of logs based on a Datadog search query. Logs that match the `include` query are passed through; others are discarded.
 */
class ObservabilityPipelineFilterProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineFilterProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineFilterProcessor = ObservabilityPipelineFilterProcessor;
/**
 * @ignore
 */
ObservabilityPipelineFilterProcessor.attributeTypeMap = {
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineFilterProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineFilterProcessor.js.map